import { render, staticRenderFns } from "./daily-spirometer-readings.vue?vue&type=template&id=51d48c66&scoped=true&"
import script from "./daily-spirometer-readings.vue?vue&type=script&lang=js&"
export * from "./daily-spirometer-readings.vue?vue&type=script&lang=js&"
import style0 from "./daily-spirometer-readings.vue?vue&type=style&index=0&id=51d48c66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d48c66",
  null
  
)

component.options.__file = "daily-spirometer-readings.vue"
export default component.exports